import {canCallApp} from './utils.js';

const appSetString = (string) => {
  if (canCallApp('setString')) {
    Trendier.setString(string)
  }
};

export {appSetString};